module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "map",
    staticClass: "map",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('app-player', {
    attrs: {
      "map": _vm.map
    }
  }), _vm._v(" "), _c('app-search', {
    attrs: {
      "map": _vm.map
    }
  }), _vm._v(" "), _c('app-save-search-polygon', {
    attrs: {
      "map": _vm.map
    }
  }), _vm._v(" "), _c('app-ratios-vegetacion', {
    attrs: {
      "map": _vm.map
    }
  }), _vm._v(" "), _c('app-compare', {
    attrs: {
      "map": _vm.map
    }
  }), _vm._v(" "), _c('div', {
    ref: "zoomBtns",
    staticClass: "zoom-btns mt-2 ml-2"
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 border-radius-0 no-border-bottom border-top-radius",
    attrs: {
      "slot": "activator",
      "small": "",
      "depressed": "",
      "color": "green",
      "outline": ""
    },
    on: {
      "click": _vm.zoomIn
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('span', [_vm._v("Zoom +")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 border-radius-0 no-border-bottom no-border-top",
    attrs: {
      "slot": "activator",
      "ripple": false,
      "small": "",
      "depressed": "",
      "color": "green",
      "outline": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "headline primary--text"
  }, [_vm._v(_vm._s(_vm.zoom))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('nivel-zoom')))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 border-radius-0 no-border-top border-bottom-radius",
    attrs: {
      "slot": "activator",
      "small": "",
      "depressed": "",
      "color": "green",
      "outline": ""
    },
    on: {
      "click": _vm.zoomOut
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "black--text"
  }, [_vm._v("remove")])], 1), _vm._v(" "), _c('span', [_vm._v("Zoom -")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ad784d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 1043
// module chunks = 1